// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"ebb081c5fd0326ae","646":"120e26959f6d7237"}[chunkId] + ".js";
};